module.exports = __webpack_public_path__ + "static/img/banner3.6dfe6b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.jpg
// module id = pwst
// module chunks = 0